export const RELATIONSHIP_CATEGORIES = {
  ORGANISATION: "ORGANISATION",
  HOUSEHOLD: "HOUSEHOLD",
} as const;

export const SYSTEM_ROLE_CODES = {
  SYSTEM_ADMIN: "SystemAdmin",
} as const;

export const TENANT_ROLE_CODES = {
  TENANT_ADMIN: "TenantAdmin",
  SERVICE_MANAGER: "ServiceManager",
  COMMUNICATIONS_SENDER: "CommunicationsSender",
  SELF_EMPLOYED_STAFF: "SelfEmployedStaff",
  INVOICE_REVIEWER: "InvoiceReviewer",
  READ_ONLY: "ReadOnly",
} as const;

export const FEATURE_PROFILE_CODES = {
  BASIC: "BP",
  SERVICE_MANAGEMENT: "SM",
} as const;

export const FEATURE_CODES = {
  SERVICE_DETAILS: "SERVICE_DETAILS",
  SERVICE_BRANDING: "SERVICE_BRANDING",
  SERVICE_ATTRIBUTES: "SERVICE_ATTRIBUTES",
  SERVICE_REGISTRATION: "SERVICE_REGISTRATION",
  SERVICE_AGREEMENTS_CONSENTS: "SERVICE_AGREEMENTS_CONSENTS",
  SERVICE_TEAM_ROLES: "SERVICE_TEAM_ROLES",
  SERVICE_GROUPS_CLASSES: "SERVICE_GROUPS_CLASSES",
  SERVICE_SCHEDULE_SESSIONS: "SERVICE_SCHEDULE_SESSIONS",
  SERVICE_SESSION_REPORTS: "SERVICE_SESSION_REPORTS",
  SERVICE_ROTA: "SERVICE_ROTA",
  SERVICE_CALENDAR: "SERVICE_CALENDAR",
  SERVICE_ATTENDANCE_CHECK_IN: "SERVICE_ATTENDANCE_CHECK_IN",
  SERVICE_MEMBERS: "SERVICE_MEMBERS",
  MESSAGING_AUDIENCES_COMMS: "MESSAGING_AUDIENCES_COMMS",
  AI_INTEGRATION: "AI_INTEGRATION",
} as const;

export type FeatureCode =
  typeof FEATURE_CODES[keyof typeof FEATURE_CODES];

export type RelationshipCategory =
  typeof RELATIONSHIP_CATEGORIES[keyof typeof RELATIONSHIP_CATEGORIES];
